import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about">
      <h3>About R E V E N T A</h3>
      <img
        src="https://images.unsplash.com/photo-1569424746512-4f98ac866469?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80"
        alt="assorted-color chairs"
      />
      <p>
        &emsp;Here at Reventa, we are looking to reinvent how you shop for
        second-hand furniture by connecting buyers and sellers through our
        online community. With accessibility to second-hand items at your
        fingertips, we hope to make buying second hand your go-to option when
        searching for a "new to you" piece.
        <br></br>
        <br></br>&emsp;Why is buying second-hand important?<br></br>
        <br></br>
        &emsp;According to the Environmental Protection Agency, Americans throw
        out over 12 million tons of furniture and furnishings per year, with 9
        million tons of this waste ending up in landfills. We strive to do our
        part to lower this number by making selling and purchasing second-hand
        furniture convenient and accessible to all.
        <br></br>
        <br></br>
        &emsp;Whether you are here looking for your next piece of furniture or
        selling your used items, we thank you for stopping by!{" "}
      </p>
    </div>
  );
};

export default About;
